import o from "./_development.js";
import i from "./_production.js";
import { isDev as r } from "../lib/env.js";
import "./_base.js";
import "../onenav/is-in-onenav.js";
import "../onenav/routing.js";
import "cerulean/dist/lib/product";
import "../lib/location.js";
const s = r() ? o : i;
export {
  s as default
};
//# sourceMappingURL=index.js.map
